import { customElement, property } from "lit/decorators.js";

import { getAssetUrl } from "helpers/assetHelpers";
import { inject } from "ui-common/di";
import type { IExploreCreatorsState } from "ui-common/services/explore-creators/types";
import type { IExploreCreatorsService } from "ui-common/services/explore-creators/types";
import type { ICreatorSelectState, ICreatorSelectService } from "ui-common/services/creator-select/types";
import type { CreatorItem } from "ui-components/creator-select-list/types";
import { CreatorSelectList } from "ui-components/creator-select-list/creator-select-list";

import { translate } from "../../translations/i18n";

@customElement("creator-follow")
export class CreatorFollow extends CreatorSelectList {
  static override styles = CreatorSelectList.styles;

  @inject<ICreatorSelectState>("creatorSelectState")
  protected selectState!: ICreatorSelectState;

  @inject<ICreatorSelectService>("creatorSelectService")
  protected selectService!: ICreatorSelectService;

  @inject<IExploreCreatorsState>("exploreCreatorsState")
  private creatorsState!: IExploreCreatorsState;

  @inject<IExploreCreatorsService>("exploreCreatorsService")
  private creatorsService!: IExploreCreatorsService;

  @property({ type: Array })
  followedCreators: string[] = [];

  @property({ type: Array })
  categoryIds: string[] = [];

  private readonly LIMIT = 20;

  override connectedCallback() {
    super.connectedCallback();
    this.placeholder = translate("sign-up.searchCreators");
    this.creatorsService.loadCreators(this.LIMIT, 0, false, undefined);
  }

  override updated(changedProperties: Map<string, unknown>) {
    super.updated(changedProperties);

    if (changedProperties.has("categoryIds")) {
      this.creatorsService.refetch(undefined);
    }
  }

  protected get creators(): CreatorItem[] {
    const data = this.creatorsState.creators.get();
    const influencers = data?.influencers ?? [];
    return influencers.map((c) => ({
      id: c.id,
      handle: c.handle,
      imageUrl: c.profileImagePath || c.profileImage ? getAssetUrl((c.profileImagePath || c.profileImage)!) : undefined,
    }));
  }

  protected get isLoading(): boolean {
    return this.creatorsState.loading.get();
  }

  protected onSearch(query: string): void {
    this.creatorsService.refetch(query || undefined);
  }

  protected override onSelectionChanged(): void {
    this.dispatchFollowEvent();
  }

  private dispatchFollowEvent() {
    const selectedItems = this.selectState.selectedItems.get();
    const selectedHandles = selectedItems
      .map((item) => item.handle)
      .filter((handle): handle is string => handle !== null);

    this.dispatchEvent(
      new CustomEvent("creators-selected", {
        detail: { creators: selectedHandles },
        bubbles: true,
      }),
    );
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "creator-follow": CreatorFollow;
  }
}
